module.exports = __webpack_public_path__ + "img/dots_mobile_green.51d18424.png";